export const ACCOUNT_INIT_FORM_DATA                 = 'ACCOUNT_INIT_FORM_DATA';
export const ACCOUNT_INIT_FORM_INFO                 = 'ACCOUNT_INIT_FORM_INFO';
export const ACCOUNT_TOGGLE_IMAGE                 = 'ACCOUNT_TOGGLE_IMAGE';
export const ACCOUNT_CLOSE_IMAGE                 = 'ACCOUNT_CLOSE_IMAGE';

export const ACCOUNT_SAVE_FORM_DATA                 = 'ACCOUNT_SAVE_FORM_DATA';
export const ACCOUNT_RESET_STORE                    = 'ACCOUNT_RESET_STORE';
export const ACCOUNT_TOGGLE_MODAL_FORM              = 'ACCOUNT_TOGGLE_MODAL_FORM';
export const ACCOUNT_TOGGLE_MODAL_DELETE            = 'ACCOUNT_TOGGLE_MODAL_DELETE';
export const ACCOUNT_DELETE_ITEM                    = 'ACCOUNT_DELETE_ITEM';
export const ACCOUNT_RESET_FORM_RESPONSE            = 'ACCOUNT_RESET_FORM_RESPONSE';

export const GET_TAB_SUCCESS                        = 'GET_TAB_SUCCESS';
export const GET_TAB_FAIL                           = 'GET_TAB_FAIL';

export const GET_ACCOUNT                            = 'GET_ACCOUNT';
export const GET_ACCOUNT_SUCCESS                    = 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_FAIL                       = 'GET_ACCOUNT_FAIL';

export const SET_LIST_OPEN                          = 'SET_LIST_OPEN';